// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bs_dJ";
export var topicsFilterContainer = "bs_dG";
export var topicsFilterWrapper = "bs_dH";